module.exports = __webpack_public_path__ + "static/img/svip.b56cf169.png";